module.exports = __webpack_public_path__ + "static/19_TikTok-b22b0245bfda17b24082a9e92724615a.png";